// extracted by mini-css-extract-plugin
export default {"sorted":"style_sorted__O8rTU","tabletTitle":"style_tabletTitle__gKrs9","titleTime":"style_titleTime__9prsp","tabletText":"style_tabletText__Lj21o"};